import { render, staticRenderFns } from "./TheHeaderDropdownNotification.vue?vue&type=template&id=152c3458&scoped=true&"
import script from "./TheHeaderDropdownNotification.vue?vue&type=script&lang=js&"
export * from "./TheHeaderDropdownNotification.vue?vue&type=script&lang=js&"
import style0 from "./TheHeaderDropdownNotification.vue?vue&type=style&index=0&id=152c3458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152c3458",
  null
  
)

export default component.exports